import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const WealthRouteWrapper = ({ children, type }) => {
  const { user, userType } = useSelector((state) => state.user)
  const kycStatus = user.status

  if (userType !== "WEALTH_PARTNER")
    return (
      <Navigate
        to={{
          pathname: "/forbidden",
        }}
      />
    )

  if (kycStatus !== "APPROVED")
    return (
      <Navigate
        to={{
          pathname: "/dashboard",
        }}
      />
    )

  return children
}

export default WealthRouteWrapper
